// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__y40BB","spinner":"Loading_spinner__iqXtb","spin":"Loading_spin__22wlh"};